import { ApiErrorWrapper, useApi } from '@hooks/api.hook';
import { queryKeys } from '@queries/keys';
import { useQuery } from '@tanstack/react-query';
import { ServiceSelectDto, ServicesSelectDto } from '../types/api.types';

export const useGetServices = () => {
  const { apiGet } = useApi();

  return useQuery<ServiceSelectDto[], ApiErrorWrapper, ServiceSelectDto[]>({
    queryFn: async () => {
      const result = await apiGet<ServicesSelectDto>({
        path: '/v1/data/services',
      });
      return result.services;
    },
    queryKey: queryKeys.service.getServices,
  });
};
